export const organizationCreatedNotice = (welcome) => {
  switch (welcome?.status) {
    case 'queued':
      return {
        message: 'Organização criada. O e-mail de boas-vindas será enviado ao endereço institucional.',
        severity: 'success',
      };
    case 'skipped_invalid_recipient':
      return {
        message: 'Organização criada. O e-mail institucional é inválido; a mensagem de boas-vindas não será enviada.',
        severity: 'warning',
      };
    case 'error':
      return {
        message: 'Organização criada. Não foi possível agendar o e-mail de boas-vindas.',
        severity: 'warning',
      };
    default:
      return { message: 'Organização criada.', severity: 'success' };
  }
};
